<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader
            class="w-100 d-flex justify-content-between align-items-center"
          >
            تکلیف‌های درس
            <AddHomeworkModal
              v-model="addHomework"
              @get-homework="getHomework"
            />
            <CButton
              :disabled="loading"
              color="primary"
              class="align-self-end px-4"
              @click="addHomework = true"
            >
              افزودن
            </CButton>
          </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
              class="w-100 d-flex justify-content-between h-100"
              :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
              :items="computedHomeworks"
              :fields="homeworkField"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
            >
              <template #detail="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    color="success"
                    square
                    size="sm"
                    @click="onHomeworkViewModal(item)"
                  >
                    مشاهده
                  </CButton>
                </td>
              </template>

              <template #addSurvey="{ item }">
                <td>
                  <CButton :disabled="loading" @click="onSurveyAddModal(item)">
                    <CIcon name="cil-cloud-upload" />
                  </CButton>
                </td>
              </template>
              <template #removeSurvey="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    @click="onSurveyRemoveModal(item)"
                  >
                    <CIcon name="cil-trash" />
                  </CButton>
                </td>
              </template>

              <template #edit="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    @click="onHomeworkEditModal(item)"
                  >
                    <CIcon name="cil-pen" />
                  </CButton>
                </td>
              </template>
              <template #answer="{ item }">
                <td>
                  <router-link
                    :to="`/teacher/homework/${item.id}`"
                    :item="item"
                  >
                    <CButton
                      :disabled="loading"
                      square
                      size="sm"
                      class="modal-button"
                    >
                      مشاهده
                    </CButton>
                  </router-link>
                  <router-view @go-to="goTo"></router-view>
                </td>
              </template>
              <template #remove="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    @click="onHomeworkRemoveModal(item)"
                  >
                    <CIcon name="cil-trash" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <ViewHomeworkModal
              v-model="homeworkViewModal"
              :homework="selectedItem"
            />
            <EditHomeworkModal
              v-model="homeworkEditModal"
              :homework="selectedItem"
              @get-homework="getHomework"
            />
            <RemoveHomeworkModal
              v-model="homeworkRemoveModal"
              :homework="selectedItem"
              @get-homework="getHomework"
            />
            <AddSurveyModal
              v-model="surveyAddModal"
              :homework="selectedItem"
              @get-homework="getHomework"
            />
            <RemoveSurveyModal
              v-model="surveyRemoveModal"
              :homework="selectedItem"
              @get-homework="getHomework"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader
            class="w-100 d-flex justify-content-between align-items-center"
          >
            زمان برگزاری کلاس این درس
          </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
              class="w-100 d-flex justify-content-between h-100"
              :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
              :items="computedTimes"
              :fields="timeField"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
            />
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6">
        <CCard>
          <CCardHeader
            class="w-100 d-flex justify-content-between align-items-center"
          >
            محتواهای آموزشی
            <AddMedia v-model="addMediaModal" @get-media="getCourseMedia" />
            <CButton
              :disabled="loading"
              color="primary"
              class="align-self-end px-4"
              @click="addMediaModal = true"
            >
              افزودن
            </CButton>
          </CCardHeader>
          <CCardBody class="d-flex align-items-center text-center h-100">
            <CDataTable
              class="w-100 d-flex justify-content-between h-100"
              :noItemsView="{
                noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
              }"
              :items="computedMedia"
              :fields="mediaField"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
            >
              <template #content="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    color="success"
                    square
                    size="sm"
                    @click="onMediaViewModal(item)"
                  >
                    مشاهده
                  </CButton>
                </td>
              </template>
              <template #remove="{ item }">
                <td>
                  <CButton
                    :disabled="loading"
                    color="success"
                    square
                    size="sm"
                    class="modal-button"
                    @click="onMediaRemoveModal(item)"
                  >
                    حذف
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <ViewMediaModal v-model="mediaViewModal" :media="selectedItem" />
            <RemoveMediaModal
              v-model="mediaRemoveModal"
              :media="selectedItem"
              @get-media="getCourseMedia"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import ViewHomeworkModal from "@/components/Modals/Homework/ViewHomeworkModal.vue";
import AddHomeworkModal from "@/components/Modals/Homework/AddHomeworkModal.vue";
import RemoveHomeworkModal from "@/components/Modals/Homework/RemoveHomeworkModal.vue";
import EditHomeworkModal from "@/components/Modals/Homework/EditHomeworkModal.vue";
import AddMedia from "@/components/Modals/Media/AddMedia.vue";
import ViewMediaModal from "@/components/Modals/Media/ViewMediaModal.vue";
import RemoveMediaModal from "@/components/Modals/Media/RemoveMediaModal.vue";
import AddSurveyModal from "@/components/Modals/Survey/AddSurveyModal.vue";
import RemoveSurveyModal from "@/components/Modals/Survey/RemoveSurveyModal.vue";

export default {
  name: "TeacherCourse",
  components: {
    ViewHomeworkModal,
    AddHomeworkModal,
    RemoveHomeworkModal,
    EditHomeworkModal,
    AddMedia,
    ViewMediaModal,
    RemoveMediaModal,
    AddSurveyModal,
    RemoveSurveyModal,
  },
  data() {
    return {
      loading: false,
      homeworks: [],
      courseTimes: [],
      courseFiles: [],
      homeworkField: [
        { key: "title", label: "عنوان" },
        { key: "expireDate", label: "مهلت ارسال" },
        { key: "addSurvey", label: "ارسال پاسخنامه" },
        { key: "removeSurvey", label: "حذف پاسخنامه" },
        { key: "detail", label: "مشاهده" },
        { key: "edit", label: "ویرایش" },
        { key: "answer", label: "مشاهده پاسخ ها" },
        { key: "remove", label: "حذف" },
      ],
      timeField: [
        { key: "timeDay", label: "روز" },
        { key: "timeHour", label: "ساعت" },
      ],
      mediaField: [
        { key: "title", label: "عنوان" },
        { key: "addDate", label: "تاریخ" },
        { key: "content", label: "محتوا" },
        { key: "remove", label: "حذف" },
      ],
      week: [
        "",
        "شنبه",
        "یکشنبه",
        "دوشنبه",
        "سه شنبه",
        "چهارشنبه",
        "پنج شنبه",
        "جمعه",
      ],
      addHomework: false,
      homeworkViewModal: false,
      homeworkEditModal: false,
      homeworkRemoveModal: false,
      mediaViewModal: false,
      mediaDownloadModal: false,
      mediaRemoveModal: false,
      addMediaModal: false,
      surveyAddModal: false,
      surveyRemoveModal: false,
      selectedItem: "",
    };
  },
  computed: {
    computedHomeworks() {
      return this.homeworks.map((item) => {
        return {
          ...item,
          detail: "",
          edit: "",
          answer: "",
          remove: "",
        };
      });
    },
    computedTimes() {
      return this.courseTimes.map((item) => {
        return {
          timeDay: this.week[item.dayOfWeek],
          timeHour: `${item.endTime} - ${item.startTime}`,
        };
      });
    },
    computedMedia() {
      return this.courseFiles.map((item) => {
        return {
          ...item,
          remove: "",
        };
      });
    },
  },
  mounted() {
    this.getHomework();
    this.getCourseTime();
    this.getCourseMedia();
    this.getCourse();
  },
  methods: {
    async getHomework() {
      try {
        this.loading = true;
        const { id: courseId } = this.$route.params;
        const { data } = await axios.get("/homework", {
          params: {
            courseId: courseId,
          },
        });
        this.homeworks = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getCourseTime() {
      try {
        this.loading = true;
        const { id: courseId } = this.$route.params;
        const { data } = await axios.get(`/course/${courseId}/time`);
        this.courseTimes = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getCourseMedia() {
      try {
        this.loading = true;
        const { id: courseId } = this.$route.params;
        const { data } = await axios.get("/media", {
          params: {
            courseId: courseId,
          },
        });
        this.courseFiles = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async getCourse(routeName) {
      try {
        const { id: courseId } = this.$route.params;
        const { data } = await axios.get(`/course/${courseId}`);
        routeName = `${data.name} - ${data.klass.grade.name} ${data.klass.name}`;
        this.$emit("go-to", routeName);
      } catch (error) {}
    },
    // goToAnswerList(item) {
    //   this.$router.push(`/teacher/homework/${item.id}`);
    // },
    onHomeworkViewModal(item) {
      this.selectedItem = item;
      this.homeworkViewModal = true;
    },
    onHomeworkEditModal(item) {
      this.selectedItem = item;
      this.homeworkEditModal = true;
    },
    onHomeworkRemoveModal(item) {
      this.selectedItem = item;
      this.homeworkRemoveModal = true;
    },
    onMediaViewModal(item) {
      this.selectedItem = item;
      this.mediaViewModal = true;
    },
    onMediaRemoveModal(item) {
      this.selectedItem = item;
      this.mediaRemoveModal = true;
    },
    onSurveyAddModal(item) {
      this.selectedItem = item;
      this.surveyAddModal = true;
    },
    onSurveyRemoveModal(item) {
      this.selectedItem = item;
      this.surveyRemoveModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.time-text {
  font-size: 60px;
}

.card {
  height: calc(100% - 24px);
}
</style>